document.addEventListener('DOMContentLoaded', () => {
    initSearchHeader();
});

function initSearchHeader() {
    const searchFormHeader = document.querySelector('.header #search-form-header');
    const searchHeaderToggle = document.querySelector('.header #search-header-toggle');
    const searchHeaderInput = document.querySelector('#s');
    const closeButton = document.querySelector('.search--close-button');

    // Add event listener to close button
    if (closeButton) {
        closeButton.addEventListener('click', function () {
            // Set aria-hidden to true and remove open class from searchFormHeader
            searchFormHeader.setAttribute('aria-hidden', 'true');
            searchFormHeader.classList.remove('open');
            // Remove active class from searchHeaderToggle
            searchHeaderToggle.classList.remove('active');
        });
    }

    // Add event listener to toggle button
    if (searchHeaderToggle) {

        searchHeaderToggle.addEventListener('click', function () {
            // Toggle the aria-hidden attribute of the search form header
            const ariaHidden = searchFormHeader.getAttribute('aria-hidden') === 'true' ? 'false' : 'true';
            searchFormHeader.setAttribute('aria-hidden', ariaHidden);

            // Toggle the open class on the search form header
            searchFormHeader.classList.toggle('open');
            // Toggle the open class on the search form header
            searchHeaderToggle.classList.toggle('active');
            // Focus Input
            searchHeaderInput.focus();
        });

        // Add event listener to the document for the Esc key
        document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape') {
                // Check if the search form header has the open class
                if (searchFormHeader.classList.contains('open')) {
                    // Set aria-hidden to true and remove open class from searchFormHeader
                    searchFormHeader.setAttribute('aria-hidden', 'true');
                    searchFormHeader.classList.remove('open');
                    // Remove active class from searchHeaderToggle
                    searchHeaderToggle.classList.remove('active');
                }
            }
        });

        // Add event listener for keydown events
        document.addEventListener('keydown', function (event) {
            // Check if the Tab key was pressed
            if (event.key === 'Tab') {
                // Check if the search form header has the open class
                if (searchFormHeader.classList.contains('open')) {
                    // Check if the Tab key was pressed while focus is still inside the search form header
                    const focusableElements = searchFormHeader.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'),
                        lastFocusableElement = focusableElements[focusableElements.length - 1],
                        hasFocusWithinSearchForm = searchFormHeader.contains(document.activeElement);
                    if (!hasFocusWithinSearchForm || document.activeElement === lastFocusableElement) {
                        // Set aria-hidden to true and remove open class from searchFormHeader
                        searchFormHeader.setAttribute('aria-hidden', 'true');
                        searchFormHeader.classList.remove('open');
                        // Remove active class from searchHeaderToggle
                        searchHeaderToggle.classList.remove('active');
                    }
                }
            }
        });

        // Add event listener for mouse click outside the search form header
        document.addEventListener('click', function (event) {
            if (!searchHeaderToggle.contains(event.target) && !searchFormHeader.contains(event.target) && searchFormHeader.classList.contains('open')) {
                // Set aria-hidden to true and remove open class from searchFormHeader
                searchFormHeader.setAttribute('aria-hidden', 'true');
                searchFormHeader.classList.remove('open');
                // Remove active class from searchHeaderToggle
                searchHeaderToggle.classList.remove('active');
            }
        });

    }
}